import styled from "styled-components";

import { media } from "../../../styles/media";

export const RegisterStepOneFormStyles = styled.div`
  .form {
    .firstAndLastNameContainer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .inputContainer {
        width: 186px;
      }

      ${media.maxMobile`
        flex-direction: column;
        align-items: stretch;
        /* No gap: each TextField already reserves ~28px below it for its
           errorMessage, so a gap here would make First/Last spacing larger
           than the rest of the stacked fields. */

        .inputContainer {
          width: 100%;
        }
      `}
    }

    .nextButton {
      width: 100%;
    }

    .link {
      cursor: pointer;
      color: ${({ theme }) => theme.colors.accent[400]};
      font-weight: normal;
    }

    .bottomText {
      font-weight: normal;
      color: ${({ theme }) => theme.colors.semantic.text.weak};
      font-size: 12px;
      text-align: center;
      margin: 18px 0 0 0;
    }
  }
`;
